import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { EffectiveWarning } from 'payments-lib';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import { BCScoreApiCall } from '../../utils/BiocatchUtils';
import Button from '../common/ButtonComponent';
import DateUtils from '../../utils/DateUtils';
import FrequencyUtils from '../../utils/FrequencyUtils';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import MoveMoneyApiUtils from '../../utils/MoveMoneyApiUtils';
import MoveMoneyBL from './MoveMoneyBL';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import NumberUtils from '../../utils/NumberUtils';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import SiteHeaderStore from '../../stores/SiteHeaderStore';
import UserManagementStore from '../../stores/UserManagementStore';
import config from '../../config';
import { getBrandId } from '../../utils/BrandUtils';

class ReviewPayment extends Component {
  constructor(props) {
    super(props);
    this.backClick = this.backClick.bind(this);
    this.makePayment = this.makePayment.bind(this);
    this.getRepeatDetails = this.getRepeatDetails.bind(this);
    this.getOneOffDetails = this.getOneOffDetails.bind(this);
    this.handleError = this.handleError.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.onSiteHeaderStoreChange = this.onSiteHeaderStoreChange.bind(this);
    this.close = this.close.bind(this);
    this.ok = this.ok.bind(this);
    this.clearModalConfig = this.clearModalConfig.bind(this);
    this.handlePayment = this.handlePayment.bind(this);
    this.state = {
      keypaddata: MoveMoneyStore.getEndingDetails(),
      open: true,
      end: '',
      showError: false,
      showThankYou: false,
      setFontSize: null,
      faqFlag: false,
      errorState: false,
      showNavigationConfirmation: false,
    };
  }

  componentWillMount() {
    const leaveModalTitle = this.props.content.siteHeaderModalTitle.replace(
      '{paymentType}',
      this.props.repeatPaymentOptions.isTransfer
        ? this.props.content.btnTextTansferPopup
        : this.props.content.btnTextPaymentPopup
    );

    const primaryButtonText =
      this.props.content.leaveMoveMoneyPrimaryButtonText.replace(
        '{paymentType}',
        this.props.repeatPaymentOptions.isTransfer
          ? this.props.content.btnTextTansferPopup
          : this.props.content.btnTextPaymentPopup
      );

    const modalConfig = {
      displayLeavePopup: true,
      title: leaveModalTitle,
      body: this.props.content.leaveMoveMoneyBodyText,
      secondaryButtonText: this.props.content.leaveModalSecondaryButtonText,
      primaryButtonText,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfig);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentWillReceiveProps(nextProps) {
    // this is added to make payment call when payment is authorised from soft token
    if (
      nextProps.makePaymentCall &&
      nextProps.makePaymentCall !== this.props.makePaymentCall
    ) {
      this.makePayment(nextProps.makePaymentCall);
    }
  }

  componentWillUnmount() {
    this.clearModalConfig();
  }

  onSiteHeaderStoreChange() {
    const toBeSelectedItem = SiteHeaderStore.getToBeSelectedMenu();
    if (!_.isEmpty(toBeSelectedItem)) {
      this.setState({
        showNavigationConfirmation: true,
      });
    }
  }
  getBalanceLeft(currentBalance) {
    return NumberUtils.appendCurrency(
      '{}',
      currentBalance - this.props.repeatData.amount
    );
  }
  getOneOffDetails() {
    const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
      this.props.repeatData.futureDate
    );
    const whenDate = MoveMoneyBL.getDateModified(
      this.props.repeatData.futureDate,
      dateDifference
    );
    const balanceAmt = this.getBalanceLeft(this.props.currentBalance);
    return (
      <div className="review__frequency__oneoff">
        <div className="c-field">
          <label className="c-field__label c-field__label--block" htmlFor="f3">
            Date
            <div className="c-field__instructions">{whenDate}</div>
          </label>
        </div>
        {dateDifference === 0 ? (
          <div className="c-field">
            <label
              className="c-field__label c-field__label--block"
              htmlFor="f3"
            >
              {this.props.content.balanceMsg}
              <div className="c-field__instructions">{balanceAmt}</div>
            </label>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
  getRepeatDetails() {
    const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
      this.props.repeatData.startDate
    );
    const oftenText = FrequencyUtils.getFrequencyValue(
      this.props.repeatData.howOften
    );
    const startDate = MoveMoneyBL.getDateModified(
      this.props.repeatData.startDate,
      dateDifference
    );
    let endDateLabel = '';
    let explanation = this.props.content.reviewSOMsg;
    switch (this.props.repeatData.stopWhen) {
      case '1':
        endDateLabel = 'when I cancel it';
        break;

      case '2':
        endDateLabel = 'after ';
        const timeContent =
          this.props.repeatData.endValue > 1
            ? this.props.content.noOfPayments
            : this.props.content.noOfPayment;
        endDateLabel += `${this.props.repeatData.endValue} </strong> <strong>  ${timeContent}`;
        break;
      case '3':
        const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
          this.props.repeatData.endValue
        );
        const endDate = MoveMoneyBL.getDateModified(
          this.props.repeatData.endValue,
          dateDifference
        );
        endDateLabel = endDate;
        explanation = this.props.content.reviewSOMsg1;
    }

    explanation = explanation.replace('{oftenText}', oftenText);
    explanation = explanation.replace('{startDate}', startDate);
    explanation = explanation.replace('{endDateLabel}', endDateLabel);
    return (
      <div className="c-field">
        <label className="c-field__label c-field__label--block" htmlFor="f3">
          {this.props.content.repeatPayment}
          <div
            className="c-field__instructions"
            dangerouslySetInnerHTML={{ __html: explanation }}
          />
        </label>
      </div>
    );
  }
  getTransferBalance() {
    let balanceAmt = NumberUtils.appendCurrency(
      '{}',
      this.props.currentBalance - this.props.repeatData.amount
    );
    return (
      <div className="review__frequency__oneoff">
        <div className="c-field">
          <label className="c-field__label c-field__label--block" htmlFor="f3">
            {this.props.content.balanceMsg}
            <div className="c-field__instructions">{balanceAmt}</div>
          </label>
        </div>
      </div>
    );
  }
  backClick() {
    this.props.handleEwActions('reviewContinue', { val: false });
    this.props.onReviewBlack();
  }
  checkReferenceEmpty() {
    if (
      this.props.repeatData.hasOwnProperty('reference') &&
      this.props.repeatData.reference.trim().length > 0
    ) {
      return true;
    }
    return false;
  }
  clearModalConfig() {
    const modalConfig = {
      displayLeavePopup: false,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfig);
  }
  close() {
    this.setState({ showError: false });
  }

  goToManagePayees() {
    this.props.goToManagePayees();
  }
  handleError() {
    let modalTitle = '';
    let bodyContent = <p>{this.state.errorState.message}</p>;
    let footerButtons = (
      <div className="review-modal__options">
        <button
          type="button"
          onClick={this.ok}
          className="c-btn c-btn--default c-modal__button"
        >
          OK
        </button>
      </div>
    );
    return (
      <PatternLibModalComponent
        show={this.state.showError}
        customClass={'c-modal'}
        onHide={() => this.setState({ showError: false })}
        bsSize={'medium'}
        modalHeading={modalTitle}
        modalBody={bodyContent}
        modalFooter={footerButtons}
        modalInContainer={false}
        closeButton
      />
    );
  }
  makePayment(makePaymentCall) {
    // TODO: Not sure why we need to set it before we consume the same data we have as props
    MoveMoneyStore.setRepeatData(this.props.repeatData);
    this.props.handleEwActions('reviewContinue', { val: false });
    const paymentRequestPacket = MoveMoneyStore.getPaymentDetails(
      this.props.repeatPaymentOptions.isTransfer
    );
    if (!makePaymentCall) {
      // only fire a request score call once
      const { bank_id: bankId } = MoveMoneyStore.getSelectedFromAccount();
      const activityType = paymentRequestPacket.payeeDetails.isBiller
        ? 'BILL_PAYMENT'
        : 'PERSON_PAYMENT';

      const paymentDetails = {
        fromAccountId: paymentRequestPacket.accountId,
        toAccountId: paymentRequestPacket.payeeDetails.beneficiary_id,
        paymentAmount: paymentRequestPacket.amount.value,
      };

      BCScoreApiCall({
        activityType,
        bankId,
        context: 'PAYMENT',
        paymentDetails,
      });
    }
    this.clearModalConfig();
    // for transfer case
    this.props.viewLoader(true);
    const repeatData = this.props.repeatData;
    repeatData.repeatPaymentOptions = this.props.repeatPaymentOptions;
    if (this.props.repeatPaymentOptions.isTransfer) {
      const fromSelectedAccount = MoveMoneyStore.getSelectedAccount();
      const toSelectedAccount = MoveMoneyStore.getSelectedToAccount();
      const fromSelectedPot = MoveMoneyStore.getSelectedPotId();
      const toSelectedPot = MoveMoneyStore.getSelectedToPotId();
      MoveMoneyActionCreator.makeTransfer(
        fromSelectedAccount,
        toSelectedAccount,
        fromSelectedPot,
        toSelectedPot,
        paymentRequestPacket
      );
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_name_transfers,
        'click'
      );
    } else {
      MoveMoneyActionCreator.makePayment(paymentRequestPacket);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_name_payments_confirmation,
        'click'
      );
    }
  }
  ok() {
    this.props.onReviewBlack();
  }
  renderFormField() {
    return (
      <div>
        {this.props.repeatAccountValid ? (
          <div>
            <div className="c-field">
              <label
                className="c-field__label c-field__label--block"
                htmlFor="f3"
              >
                {this.props.content.paymentType}
                <div className="c-field__instructions">
                  {this.props.repeatData.oneOffPayment
                    ? this.props.content.oneOffPayment
                    : this.props.content.repeatingPayment}
                </div>
              </label>
            </div>
            {this.props.repeatData.oneOffPayment
              ? this.getOneOffDetails()
              : this.getRepeatDetails()}
          </div>
        ) : (
          this.getTransferBalance()
        )}
      </div>
    );
  }
  renderOptions() {
    let btnText = this.props.content.paymentBtn;
    if (this.props.repeatPaymentOptions.isTransfer) {
      btnText = this.props.content.transferBtn;
    }
    return (
      <div className="review__options">
        <Button
          btnName="Back"
          className="c-btn c-btn--secondary review__options__back"
          onClick={this.backClick}
        />
        <Button
          btnName={btnText}
          className="c-btn c-btn--default review__options__proceed"
          onClick={this.makePayment}
        />
      </div>
    );
  }
  renderReference() {
    return (
      <div className="c-field">
        <label className="c-field__label c-field__label--block" htmlFor="f3">
          Reference
          <div className="c-field__instructions">
            {this.props.repeatData.reference}
          </div>
        </label>
      </div>
    );
  }

  handlePayment() {
    const { handleEwActions } = this.props;
    MoveMoneyApiUtils.isSourceIdSame(true);
    handleEwActions('reset', { val: false });
    this.makePayment();
  }

  render() {
    const {
      repeatPaymentOptions,
      fromAccount,
      toAccount,
      payee,
      handleEwActions,
      handleEwLibResponse,
      effectiveWarningError,
      session,
      envConfig,
      continueOnReview,
      warningId,
      ...reviewProps
    } = this.props;

    const ewData = {
      warningId,
      reviewData: { ...reviewProps, repeatPaymentOptions },
      accountDetails: {
        fromAccount,
        toAccount,
        payee,
      },
    };

    return (
      <div>
        <EffectiveWarning
          envConfig={{ ...envConfig, brandId: getBrandId(envConfig.brandId) }}
          effectiveWarning={ewData}
          session={session}
          user={{ id: UserManagementStore.getCADetails().id }}
          onAction={handleEwActions}
          onBack={this.backClick}
          onContinue={this.handlePayment}
          startPage="EwPaymentReason"
        />
      </div>
    );
  }
}

ReviewPayment.propTypes = {
  content: PropTypes.object,
  repeatData: PropTypes.object,
  currentBalance: PropTypes.number,
  repeatPaymentOptions: PropTypes.object,
  continueClick: PropTypes.func,
  viewLoader: PropTypes.func,
  isTransfer: PropTypes.bool,
  repeatAccountValid: PropTypes.bool,
  onReviewBlack: PropTypes.func,
  goToManagePayees: PropTypes.func,
  refreshMoveMoney: PropTypes.func,
};

ReviewPayment.defaultProps = {
  content: '',
  repeatData: {},
  repeatAccountValid: true,
  isTransfer: false,
  currentBalance: 0,
};
export default ReviewPayment;
